module.exports = __webpack_public_path__ + "img/17_34.0c43fc44.png";